const { default: axios } = require("axios");

const FormAjax = function () {

    const formAjax = function (e) {

        e.preventDefault();


        const form = $(this);
        const values = form.serialize();
        const button = form.find('button');

        button.attr('disabled', 'disabled');
        button.text('Enviando');

        axios.post(form.attr('action'), values, {
            headers: {'X-Requested-With': 'XMLHttpRequest'}
        })
        .then(function (response) {
            const data = response.data;

            console.log(data);

            if (data.error == false) {
                form.prepend('<div class="alert alert-success w-100" role="alert">' + data.message + '</div>');

                if(data.result.url_whats !== undefined){
                    window.open(data.result.url_whats, '_blank').focus();
                }
            }else{
                form.prepend('<div class="alert alert-danger w-100" role="alert">' + data.message + '</div>');
            }

            setTimeout(() => {
                form.find('.alert').slideToggle('slow', function(){
                    $(this).remove();
                });
            }, 5000);

            // envio GA
            /* gtag('event', 'send-form-one', {
                formSend: 'success'
            });
            fbq('trackCustom', 'form-one', {'send-form-one': 'success'}); */

            console.log('formSend : success');

            form[0].reset();

            button.removeAttr('disabled');
            button.text('Enviar');                
        });

        e.preventDefault();
    }

    return {
        init: function () {
            $(document).on('submit', '.form-ajax', formAjax);
        }
    }
}();

module.exports = FormAjax;